import { Component, computed, input } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { PlotAreaFilterModel } from "./search-filter-plotarea.model";
import { ExpandableMinMaxFilterComponent, MinMaxFilterConfig } from "src/app/shared-components/expandable-min-max-filter/expandable-min-max-filter.component";

@Component({
    selector: "search-filter-plotarea",
    imports: [ExpandableMinMaxFilterComponent],
    templateUrl: "./search-filter-plotarea.component.html",
    styleUrl: "./search-filter-plotarea.component.scss",
})
export class SearchFilterPlotAreaComponent {
     filterForm = input.required<FieldTree<PlotAreaFilterModel>>();

   protected filterConfig = computed<MinMaxFilterConfig<PlotAreaFilterModel>>(() => ({
        filterForm: this.filterForm,
        title: "Tomtestørrelse",
        fromFieldAccessor: (form) => form.plotAreaFrom,
        toFieldAccessor: (form) => form.plotAreaTo,
        expandedAccessor: (form) => form.expanded,
        fromFieldId: "plotAreaFrom",
        toFieldId: "plotAreaTo",
        cssClass: "plot-area",
    }));
}
